// fe/src/components/AuthForm.js
import React, { useState } from "react";
import api from '../utils/api';
import { useNavigate } from "react-router-dom";
import { log } from "../utils/debug";
import { GoogleLogin } from '@react-oauth/google';

const AuthForm = ({ onAuth }) => {
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: ""
  });
  const [errMsg, setErrMsg] = useState("");

  const toggleMode = () => {
    setErrMsg("");
    setForm({ name: "", email: "", password: "" });
    setMode(mode === "login" ? "register" : "login");
  };

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrMsg("");
    log("🧾 Submitting auth form", mode, {name: form.name, email: form.email, password: "••••••••"});

    try {
      if (mode === "login") {
        const res = await api.post("/login", {
          email: form.email,
          password: form.password
        }, { withCredentials: true });

        log("✅ Login response:", res.data);

        if (res.data.access_token) {
          localStorage.setItem("access_token", res.data.access_token);
          log("💾 Token saved to localStorage:", res.data.access_token);
          onAuth();
          navigate("/");
        } else {
          console.warn("⚠️ No access_token in login response");
          setErrMsg("Login succeeded, but no token returned.");
        }

      } else {
        const res = await api.post("/users", form);
        log("✅ Registration response:", res.data);

        if (res.data.status === "created") {
          log("✅ Account created — you're being logged in...");

          const loginRes = await api.post("/login", {
            email: form.email,
            password: form.password
          }, { withCredentials: true });

          log("✅ Auto-login after register response:", loginRes.data);

          if (loginRes.data.access_token) {
            localStorage.setItem("access_token", loginRes.data.access_token);
            log("💾 Token saved to localStorage:", loginRes.data.access_token);
            onAuth();
            navigate("/");
          } else {
            console.warn("⚠️ Registered but token missing from login response");
            setErrMsg("Registered but failed to log in.");
          }

        } else {
          console.warn("⚠️ Registration failed:", res.data);
          setErrMsg(res.data.detail || "Registration failed");
        }
      }

    } catch (err) {
      console.error("❌ Auth error:", err);
      const errorData = err.response?.data;
      console.error("Auth error:", errorData);

      if (Array.isArray(errorData?.detail)) {
        // FastAPI validation errors (422)
        const firstError = errorData.detail[0];
        setErrMsg(`${firstError.loc?.join(".")} → ${firstError.msg}`);
      } else {
        // Generic error
        setErrMsg(errorData?.detail || "Something went wrong");
      }
    }
  };

  // ✅ Add this block to render the inputs!
  return (
    <form onSubmit={handleSubmit} className="container">
      <h2>{mode === "login" ? "Login" : "Create Account"}</h2>
      {errMsg && <p style={{ color: "red" }}>{errMsg}</p>}

      {mode === "register" && (
        <input name="name" placeholder="Name" value={form.name} onChange={handleChange} required />
      )}

      <input type="email" name="email" placeholder="Email" value={form.email} onChange={handleChange} required />
      <input type="password" name="password" placeholder="Password" value={form.password} onChange={handleChange} required />
      
      <div className="button-row-div">
        <button type="submit">{mode === "login" ? "Login" : "Register"}</button>
      </div>
      <div className="button-row-div">
      <GoogleLogin
        onSuccess={async credentialResponse => {
          try {
            const idToken = credentialResponse?.credential;
            if (!idToken) {
              console.error("❌ No credential received from Google");
              return;
            }

            log("✅ Google ID Token received:", idToken);

            const res = await api.post('/auth/google', { id_token: idToken });
            log("✅ Backend response:", res.data);

            if (res.data.token) {
              localStorage.setItem("access_token", res.data.token);
              onAuth();
              navigate("/");
            } else {
              console.warn("⚠️ No token returned from backend");
            }

          } catch (err) {
            console.error("❌ Google auth failed:", err.response?.data || err.message);
          }
        }}
        onError={() => console.log('❌ Google Login Failed')}
        useOneTap
      />
      </div>

      <p style={{ marginTop: "1rem" }}>
        {mode === "login" ? "Don't have an account?" : "Already have an account?"}{" "}
        <a onClick={toggleMode} className="instavite-link">
          {mode === "login" ? "Register" : "Login"}
        </a>
      </p>
    </form>
  );
};

export default AuthForm;
